import { UseFormValues } from "@formiz/core/dist/types/form.types";

type FindFirstInvalidFormizFieldProps = {
  fields: UseFormValues["fields"];
  fieldOrder: string[];
};

export const findFirstInvalidFormizField = ({ fields, fieldOrder }: FindFirstInvalidFormizFieldProps): string | undefined => {
  return fieldOrder.find((fieldName) => {
    const field = fields[fieldName];
    if (!field) return false;

    const hasError = field.error && field.error.length > 0;
    const isExplicitlyInvalid = field.isValid === false;
    const isRequiredButEmpty = field.isRequired && (!field.value || field.value === "" || (Array.isArray(field.value) && field.value.length === 0));

    return hasError || isExplicitlyInvalid || isRequiredButEmpty;
  });
};
